import {TypeAccountRoles} from './../../shared/types/user-account.types';
import qs from 'qs';

import axiosInstance from '../protected';

import {IPageable, IPageableDto} from '../../shared/types/pageable.types';
import {IDocument} from '../../shared/types/document.types';
import {IUserAccount, IUserAccountPostBody, IUserAccountSpec} from '../../shared/types/user-account.types';

import {getUserAccountsUrl} from '../api.config';

export const UserAccountService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: IUserAccountSpec;
    } = {},
  ) {
    const res = await axiosInstance.get<IPageableDto<IUserAccount>>(getUserAccountsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: string) {
    const res = await axiosInstance.post<IUserAccount[]>(getUserAccountsUrl(`/findByUids`), [id]);

    return {data: res.data[0]};
  },

  async update(data: IUserAccount) {
    const updated = await axiosInstance.put<IUserAccount>(getUserAccountsUrl(), data);

    return updated;
  },

  async delete(id: number) {
    await axiosInstance.delete(getUserAccountsUrl(`/`), {
      data: [id],
    });
  },

  async deleteAFew(IDs: number[]) {
    const deleted = await axiosInstance.delete<number[]>(getUserAccountsUrl(), {
      params: {
        id: IDs,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return deleted;
  },

  async create(data: IUserAccountPostBody) {
    const created = await axiosInstance.post<IUserAccount>(getUserAccountsUrl(), data);

    return created;
  },

  async findByIDs(IDs: number[]) {
    const res = await axiosInstance.post<IUserAccount[]>(getUserAccountsUrl(`/findByUids`), IDs);

    return res;
  },

  async getUserPhoto(id: number) {
    const res = await fetch('/api' + getUserAccountsUrl(`/${id}/photo`));

    return res;
  },

  async addUserPhoto(id: number, data: FormData) {
    const created = await axiosInstance.put<IDocument>(getUserAccountsUrl(`/${id}/photo`), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return created;
  },

  async changePasswordAdmin(data: {uid: string; newPassword: string; isTemporary: boolean}) {
    const res = await axiosInstance.put(getUserAccountsUrl(`/resetPassword`), data);

    return res;
  },

  async changePasswordManager(data: {uid: string; newPassword: string; isTemporary: boolean}) {
    const res = await axiosInstance.put(getUserAccountsUrl(`/changePassword`), data);

    return res;
  },

  async block(uid: string, isBlock: boolean) {
    await axiosInstance.put(getUserAccountsUrl(`/${uid}/block`), undefined, {
      params: {
        isBlock,
      },
    });
  },

  async findInGroups(role: TypeAccountRoles, inGroups: number[]) {
    const res = await axiosInstance.get<IUserAccount[]>(getUserAccountsUrl(), {
      params: {
        role,
        inGroups,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async findOutOfGroups(role: TypeAccountRoles, exGroups: number[]) {
    const res = await axiosInstance.get<IUserAccount[]>(getUserAccountsUrl('/findByGroups'), {
      params: {
        role,
        exGroups,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },
};
